<script>
  import Divider from "components/Divider.svelte";
  import { currentLang } from "stores.js";
  import ExtraInfo from "./ExtraInfo.svelte";
  import RegistrationButton from "./RegistrationButton.svelte";
  import ClosedRegistration from "./ClosedRegistration.svelte";

  export let event;
  export let registrations;
</script>

<div id={event.slug} class="wrapper">
  <div class="content">
    <a class="link" href={`#${event.slug}`}>
      <h2 class="title">{event.title[$currentLang]}</h2>
    </a>
    {#if event.teaser && event.teaser[$currentLang]}
      <p class="teaser">{event.teaser[$currentLang]}</p>
    {/if}
    <Divider />
    <p class="date">
      {event.date[$currentLang] ? event.date[$currentLang] : ""}
      <br />
      {#if event.location}
        {event.location[$currentLang] ? event.location[$currentLang] : ""}
      {/if}
      <br />
      <span class="detail">
        {#if event.address1}
          {event.address1[$currentLang] ? event.address1[$currentLang] : ""}
        {/if}
      </span>
      <br />
      <span class="detail">
        {#if event.address2}
          {event.address2[$currentLang] ? event.address2[$currentLang] : ""}
        {/if}
      </span>
    </p>
    {#if event.extraInfo1}
      <ExtraInfo center={true} info={event.extraInfo1} />
    {/if}

    {#if event.open}
      <RegistrationButton
        {event}
        {registrations}
        on:unregister
        on:register
        on:loginAndRegister
      />
    {:else}
      <ClosedRegistration on:login />
    {/if}
  </div>
</div>

<style>
  .wrapper {
    background-color: #f6f6f6;
    padding-top: 36px;
    padding-bottom: 32px;
  }

  .content {
    max-width: 900px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .teaser {
    margin: 48px auto 0;
    max-width: 600px;
  }

  .link,
  .link:active,
  .link:visited {
    color: black;
    cursor: default;
  }

  .title {
    margin: 0 auto;
    font-weight: 200;
    text-transform: uppercase;
    letter-spacing: 0.03rem;
    text-align: center;
    max-width: 300px;
    word-wrap: break-word;
  }

  .date {
    margin: 0;
    text-align: center;
    font-weight: 600;
  }

  @media only screen and (min-width: 600px) {
    .title {
      font-size: 33px;
      max-width: 960px;
    }
    .date {
      font-size: 18px;
    }
  }

  .detail {
    font-weight: 200;
  }

  p {
    margin: 0;
  }
</style>
